import Store from 'store/store';
import { BASE_REGION_CODE } from './constants';

/**
 * Studio-specific configuration object
 * Centralizes all conditional logic based on studio type (Focus Features vs Universal)
 */
const STUDIO_CONFIG = {
	focus: {
		// Display options
		showSocials: false,
		showScrollArrows: false,

		// Home page sections
		homeSections: ['synopsis'], // Focus only shows synopsis on home
	},

	universal: {
		// Display options
		showSocials: true,
		showScrollArrows: true,

		// Home page sections
		homeSections: ['synopsis', 'gallery', 'videos'], // Universal shows all sections
	},
};

/**
 * Get the current studio configuration based on Store state
 * @returns {Object} Studio configuration object
 */
export function getStudioConfig() {
	const isFocus = isFocusStudio();
	return STUDIO_CONFIG[isFocus ? 'focus' : 'universal'];
}

/**
 * Check if current studio is Focus Features
 * @returns {boolean}
 */
export function isFocusStudio() {
	return Store.get().domains?.isFocus === true;
}

export function getCurrentRegion() {
	const { regions, selectedRegion } = Store.get().domains || {};
	return regions?.find(region => region.region_id === selectedRegion) || null;
}

export function getCurrentRegionCode() {
	const region = getCurrentRegion();
	return region?.region_code || null;
}

export function isBaseRegion() {
	const region = getCurrentRegion();
	return region?.region_code === BASE_REGION_CODE;
}

export function getCurrentHubDomain() {
	const region = getCurrentRegion();
	return region?.domain_name || null;
}

export function getCurrentMovieUrl(slug) {
	const baseUrl = `https://${getCurrentHubDomain()}`;
	const path = isFocusStudio() ? 'films' : 'movies';
	return `${baseUrl}/${path}/${slug || ''}`; 
}

export function getStudioSlug() {
	const region = getCurrentRegion();
	return region?.studio_slug || null;
}

export function getCurrentRegionSettings() {
	const region = getCurrentRegion();
	return region?.region_metadata || {};
}
